// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .itemInfo_details {
    display: flex;
    flex-flow: column;
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-flow: row;
      justify-content: space-between;
    }
  }
  .itemInfo_details_items {
    display: flex;
    flex-flow: row;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    @media ${(props) => props.theme.mediaQuery.large} {
      flex-flow: column;
      margin-bottom: 0;
    }
  }

  .itemInfo_details_items_leftMargin {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: 0;
    }
  }
  .item-preview-details {
    @media ${(props) => props.theme.mediaQuery.medium} {
      min-height: 115px;
    }
  }
  .brand-logo {
    text-align: center;
  }
  .itemInfo_details_items,
  .item-preview-details,
  .order_item_image {
    opacity: ${(props) => (props.isReturnOrRefund ? 0.5 : 1)};
  }
  .bia-atb {
    text-align: center;
    border: 0px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    border-radius: 6px;
    font-size: 14px;
    min-height: 26px;
    color: ${(props) => props.theme.colorPalette.white};
    height: 36px;
    margin-left: ${(props) => (props.isShowWriteReview ? '15px' : '0px')};
    background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
    text-transform: capitalize;
  }

  .action-container {
    display: flex;
  }

  .review-button {
    border: 1px solid black;
    text-align: center;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    border-radius: 6px;
    width: 110px;
    height: 28px;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  @media screen and (max-width: 350px) {
    .review-button {
      padding-left: 0px;
      padding-right: 0px;
    }
    .bia-atb {
      margin-left: ${(props) => (props.isShowWriteReview ? '5px' : '0px')};
      padding-left: 3px;
      padding-right: 3px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .bia-atb {
      margin-left: ${(props) => (props.isShowWriteReview ? '5px' : '0px')};
      padding-left: 10px;
      padding-right: 10px;
    }
    .review-button {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`;

export default styles;
